import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  getById,
  search,
  create,
  update,
  getSelectListProject,
  getSelectListLot,
  getListProjectAssignmentUser,
  assignUserToProject,
  getListBuilderUser,
  getListUserSelect,
  getSelectSubcontractorListProject,
  getSelectBuilderListProject,
  getProjectSetting,
  updateProjectSetting,
  getProjectSettingNoticeRFS,
  updateProjectSettingNoticeRFS,
  createAssigneeNotice,
  getAssigneeNoticeByProject,
  getProjectByUserId,
  reassignProjectCoordinator,
  reassignProjectOwner,
  getProjectDocumentTypeList,
  getProjectDocumentByDocumentType,
  uploadProjectDocumentToServer,
  removeProjectDocument,
  updateProjectDocumentName,
  getProjectDocumentShareLot,
  updateProjectDocumentShareLot,
  exportProjectList,
  updateHomeownerFolderTitle,
  getImportStatusByProject,
  importRFSToProject,
  importWorkOrderToProject,
  importPurchaseOrderToProject,
  getListDefaultCustomTemplate,
  getListDefaultCustomTemplate2,
  createNewProjectEOCTemplate,
  createNewProjectEPLTemplate,
  selectListCustomTemplate,
  getCustomTemplateDetail,
  getCustomTemplateDetail2,
  editCustomTemplate,
  editEPLTemplate,
  getBuilderName,
  duplicateEOCTemplate,
  copyEOCTemplate,
  getListCopyEOCProject,
  createNewCategory,
  suggestInfoCategory,
  getListCategory,
  getCategoryProfileDetails,
  editCategoryProfile,
  getSelectedTemplateCategory,
  editCategoryImages,
  deleteCategoryImages,
  deleteCategoryItem,
  createNewInventoryItem,
  getListCategoryDropdown,
  getListInventoryItem,
  getInventoryItemProfile,
  deleteImageInventoryItem,
  deleteAttachFileInventoryItem,
  postImageInventoryItem,
  postAttachFileInventoryItem,
  deleteInventoryItem,
  editInventoryItem,
  getListPhaseToLotInventoryItem,
  assignPlanToLotInventoryItem,
  fetchListLotInventoryItem,
  onEditListLotInventoryItem,
  deleteListLotInventoryItem,
  getSuggestTemplateName,
  getSuggestData,
  setupProjectDocumentAWS,
  uploadProjectDocumentToS3,
  suggestLocationTagsHomeInventory,
  getInventoryTemplateList,
  postInventoryTemplateList,
  getInventoryItemTemplateList,
  postInventoryItemTemplateList,
  postInventoryItemTemplateNotExistList,
  getRequestTypeToMapping,
  postRequestTypeTemplate,
  deleteRequestTypeTemplate,
  copyEOFTemplate
} from './api';

import MaintenanceSaga from './Components/Maintenance/saga';
import * as ProjectActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* getByIdAsync(action) {
  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_PROJECT_BY_ID_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.SEARCH_PROJECT_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createAsync(action) {
  const result = yield call(create, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.CREATE_PROJECT_SUCCESS,
        params: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Project created' })
    ];
  } else {
    yield put({
      type: ProjectActionType.CREATE_UPDATE_PROJECT_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* updateAsync(action) {
  const result = yield call(update, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.UPDATE_PROJECT_SUCCESS,
        params: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({
      type: ProjectActionType.CREATE_UPDATE_PROJECT_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* selectListProjectAsync(action) {
  const result = yield call(getSelectListProject, action.params.param);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.SELECT_LIST_PROJECT_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectListLotAsync(action) {
  const result = yield call(getSelectListLot, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.SELECT_LIST_LOT_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListProjectAssignmentUserAsync(action) {
  const result = yield call(getListProjectAssignmentUser, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_LIST_PROJECT_ASSIGNMENT_USER_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* assignUserToProjectAsync(action) {
  const result = yield call(assignUserToProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.ASSIGN_USER_TO_PROJECT_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListBuilderUserAsync(action) {
  const result = yield call(getListBuilderUser, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_LIST_BUILDER_USER_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListUserSelectAsync(action) {
  const result = yield call(getListUserSelect, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.GET_LIST_USER_SUCCESS, data: result.data })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    if (action.callback) {
      action.callback();
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* selectSubcontractorListProjectAsync(action) {
  const result = yield call(
    getSelectSubcontractorListProject,
    action.params.param
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.SELECT_LIST_PROJECT_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectBuilderListProjectAsync(action) {
  const result = yield call(getSelectBuilderListProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.SELECT_LIST_PROJECT_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getProjectSettingAsync(action) {
  const result = yield call(getProjectSetting, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_SETTING_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateProjectSettingAsync(action) {
  const result = yield call(updateProjectSetting, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_SETTING_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getProjectSettingNoticeRFSAsync(action) {
  const result = yield call(getProjectSettingNoticeRFS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_SETTING_NOTICE_RFS_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateProjectSettingNoticeRFSAsync(action) {
  const result = yield call(updateProjectSettingNoticeRFS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_SETTING_NOTICE_RFS_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createAssigneeNoticeAsync(action) {
  const result = yield call(createAssigneeNotice, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.SETTING_UPDATE_ASSIGNEE_NOTICE_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getAssigneeNoticeByProjectAsync(action) {
  const result = yield call(getAssigneeNoticeByProject, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.SETTING_UPDATE_ASSIGNEE_NOTICE_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getProjectByUserIdAsync(action) {
  const result = yield call(getProjectByUserId, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_BY_USER_ID_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* reassignProjectOwnerAsync(action) {
  const result = yield call(reassignProjectOwner, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.REASSIGN_PROJECT_OWNER_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* reassignProjectCoordinatorAsync(action) {
  const result = yield call(reassignProjectCoordinator, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.REASSIGN_PROJECT_COORDINATOR_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListProjectDocumentTypeAsync(action) {
  const result = yield call(getProjectDocumentTypeList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_PROJECT_DOCUMENT_TYPE_SUCCESS,
      data: result.data
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getProjectDocumentByDocumentTypeAsync(action) {
  const result = yield call(getProjectDocumentByDocumentType, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS,
      data: {
        documentTypeId: action.params.projectDocumentTypeId,
        documentList: result.data
      }
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* uploadProjectDocumentToServerAsync(action) {
  const result = yield call(uploadProjectDocumentToServer, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.UPLOAD_PROJECT_DOCUMENT_TO_SERVER_SUCCESS,
      data: {
        documentTypeId: action.params.projectDocumentTypeId,
        documentItem: result.data
      }
    });
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    if (action.callback) {
      action.callback(false, result.data);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* removeProjectDocumentAsync(action) {
  const result = yield call(removeProjectDocument, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    const { projectId, projectDocumentTypeId } = action.params;
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
        params: {
          projectId,
          projectDocumentTypeId
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updateProjectDocumentNameAsync(action) {
  const result = yield call(updateProjectDocumentName, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    const { projectId, projectDocumentTypeId } = action.params;
    yield [
      put({
        type: ProjectActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
        params: {
          projectId,
          projectDocumentTypeId
        },
        callback: action.callback
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getProjectDocumentShareLotAsync(action) {
  const result = yield call(getProjectDocumentShareLot, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_PROJECT_DOCUMENT_SHARE_LOT_SUCCESS,
      data: result.data
    });

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updateProjectDocumentShareLotAsync(action) {
  const result = yield call(updateProjectDocumentShareLot, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const { projectId, projectDocumentTypeId } = action.params;

    yield [
      put({
        type: ProjectActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
        params: {
          projectId,
          projectDocumentTypeId
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* exportProjectListAsync(action) {
  const result = yield call(exportProjectList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    //get file name
    let filename = 'projects.xlsx';
    let disposition = result.headers['content-disposition'];
    if (disposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    let blob = new Blob([result.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // for IE browser
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // for Non-IE (chrome, firefox etc.)
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updateHomeownerFolderTitleAsync(action) {
  const result = yield call(updateHomeownerFolderTitle, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const { projectId } = action.params;

    yield [
      put({
        type: ProjectActionType.GET_LIST_PROJECT_DOCUMENT_TYPE_ASYNC,
        params: {
          projectId
        },
        callback: action.callback
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* importRFSToProjectAsync(action) {
  const result = yield call(importRFSToProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    console.log('importing rfs...');
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getImportStatusByProjectAsync(action) {
  const result = yield call(getImportStatusByProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_IMPORT_STATUS_BY_PROJECT_SUCCESS,
      data: result.data
    });

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* importWorkOrderToProjectAsync(action) {
  const result = yield call(importWorkOrderToProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    console.log('importing work order...');
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* importPurchaseOrderToProjectAsync(action) {
  const result = yield call(importPurchaseOrderToProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    console.log('importing purchase order...');
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListDefaultCustomTemplateAsync(action) {
  const result = yield call(getListDefaultCustomTemplate, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: ProjectActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE_SUCCESS, data: result.data});
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getListDefaultCustomTemplate2Async(action) {
  const result = yield call(getListDefaultCustomTemplate2, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: ProjectActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_SUCCESS, data: result.data});
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* createNewProjectEOCTemplateAsync(action) {
  const result = yield call(createNewProjectEOCTemplate, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Created'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* createNewProjectEPLTemplateAsync(action) {
  const result = yield call(createNewProjectEPLTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Template created'});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* selectListCustomTemplateAsync(action) {
  const result = yield call(selectListCustomTemplate, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.SELECT_CUSTOM_TEMPLATE_SUCCESS, data: result.data}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getCustomTemplateDetailAsync(action) {
  const result = yield call(getCustomTemplateDetail, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL_SUCCESS, data: result.data});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getCustomTemplateDetail2Async(action) {
  const result = yield call(getCustomTemplateDetail2, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL2_SUCCESS, data: result.data});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* editCustomTemplateAsync(action) {
  const result = yield call(editCustomTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* editEPLTemplateAsync(action) {
  const result = yield call(editEPLTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getBuilderNameAsync(action) {
  const result = yield call(getBuilderName, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.GET_BUILDER_NAME_SUCCESS, data: result.data})
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* duplicateEOCTemplateAsync(action) {
  const result = yield call(duplicateEOCTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.DUPLICATE_EOC_TEMPLATE_SUCCESS, data: result.data}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Duplicated'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* copyEOCTemplateAsync(action) {
  const result = yield call(copyEOCTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.COPY_EOC_TEMPLATE_SUCCESS, data: result.data}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Copied'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* copyEOFTemplateAsync(action) {
  const result = yield call(copyEOFTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.COPY_EOF_TEMPLATE_SUCCESS, data: result.data}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Copied'})
    ];
    if (action.callback) {
      action.callback(true);
    }
  } else {
    if (action.callback) {
      action.callback(false);
    }
  }
}

export function* getListCopyEOCProjectAsync(action) {
  const result = yield call(getListCopyEOCProject, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ProjectActionType.GET_LIST_COPY_EOC_TEMPLATE_LIST_SUCCESS, data: result.data})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* createNewCategoryAsync(action) {
  const result = yield call(createNewCategory, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Created'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else if (statusCode === 400) {
    yield put({ type: ProjectActionType.CREATE_NEW_CATEGORY_ERROR, data: {error: 'This category already exists'}});
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data.error
    });
  }
}

export function* suggestInfoCategoryAsync(action) {
  const result = yield call(suggestInfoCategory, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.SUGGEST_INFORMATION_CATEGORY_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    } else {
      yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
    }
  }
}

export function* getListCategoryAsync(action) {
  const result = yield call(getListCategory, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_CATEGORY_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    } else {
      yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
    }
  } else if (statusCode === 204) {
    yield put({
      type: ProjectActionType.GET_LIST_CATEGORY_SUCCESS, data: []
    });
  }
}

export function* getCategoryProfileDetailsAsync(action) {
  const result = yield call(getCategoryProfileDetails, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_CATEGORY_PROFILE_DETAILS_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    } else {
      yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
    }
  }
}

export function* getCategoryProfileImagesDetailsAsync(action) {
  const result = yield call(getCategoryProfileDetails, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_SUCCESS, data: result.data.images
    });
    if (action.callback) {
      action.callback();
    } else {
      yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
    }
  }
}

export function* editCategoryProfileAsync(action) {
  const result = yield call(editCategoryProfile, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getSelectedTemplateCategoryAsync(action) {
  const result = yield call(getSelectedTemplateCategory, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_SELECTED_TEMPLATE_CATEGORY_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* editCategoryImagesAsync(action) {
  const result = yield call(editCategoryImages, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* deleteCategoryImagesAsync(action) {
  const result = yield call(deleteCategoryImages, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* deleteCategoryItemAsync(action) {
  const result = yield call(deleteCategoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* createNewInventoryItemAsync(action) {
  const result = yield call(createNewInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({type: ProjectActionType.CREATE_NEW_INVENTORY_ITEM_SUCCESS, data: result.data}),
      put({
        type: NotifyActionType.NOTIFY_SUCCESS, data: 'Created'
      })
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getListCategoryDropdownAsync(action) {
  const result = yield call(getListCategoryDropdown, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_CATEGORY_DROPDOWN_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getListInventoryItemAsync(action) {
  const result = yield call(getListInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_INVENTORY_ITEM_SUCCESS,
      data: result.data,
      request: action.params
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getInventoryItemProfileAsync(action) {
  const result = yield call(getInventoryItemProfile, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_INVENTORY_ITEM_PROFILE_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getImagesItemProfileAsync(action) {
  const result = yield call(getInventoryItemProfile, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_INVENTORY_ITEM_IMAGES_SUCCESS, data: result.data.images
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getAttachmentsItemProfileAsync(action) {
  const result = yield call(getInventoryItemProfile, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_INVENTORY_ITEM_ATTACHMENT_SUCCESS, data: result.data.attachments
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* deleteImageInventoryItemAsync(action) {
  const result = yield call(deleteImageInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* deleteAttachFileInventoryItemAsync(action) {
  const result = yield call(deleteAttachFileInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* postImageInventoryItemAsync(action) {
  const result = yield call(postImageInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* postAttachFileInventoryItemAsync(action) {
  const result = yield call(postAttachFileInventoryItem, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: ProjectActionType.GET_INVENTORY_ITEM_ATTACHMENT_ASYNC,
        params: {
          id: action.params.inventoryId
        }
      })
    ];
    if (action.callback) {
      action.callback(true);
    }
  } else {
    if (action.callback) {
      action.callback(false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* deleteInventoryItemAsync(action) {
  const result = yield call(deleteInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* editInventoryItemAsync(action) {
  const result = yield call(editInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* assignPlanToLotInventoryItemAsync(action) {
  const result = yield call(assignPlanToLotInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getListPhaseToLotInventoryItemAsync(action) {
  const result = yield call(getListPhaseToLotInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}
export function* getListLotAssignInventoryItemAsync(action) {
  const result = yield call(fetchListLotInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* onEditListLotInventoryItemAsync(action) {
  const result = yield call(onEditListLotInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* deleteListLotInventoryItemAsync(action) {
  const result = yield call(deleteListLotInventoryItem, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted'
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getSuggestTemplateNameAsync(action) {
  const result = yield call(getSuggestTemplateName, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_SUGGEST_TEMPLATE_NAME_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* getSuggestDataAsync(action) {
  const result = yield call(getSuggestData, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_SUGGEST_DATA_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* setupProjectDocumentAWSAsync(action) {
  const result = yield call(setupProjectDocumentAWS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.SETUP_PROJECT_DOCUMENT_AWS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* suggestLocationTagsHomeInventoryAsync(action) {
  const result = yield call(suggestLocationTagsHomeInventory, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.SUGGEST_LOCATION_TAGS_HOME_INVENTORY_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* uploadProjectDocumentToS3Async(action) {
  const paramsUpload = {
    projectId: action.params.projectId,
    file: action.params.file,
    config: action.params.config
  };
  yield call(uploadProjectDocumentToS3, paramsUpload, action.callback);
}

export function* getInventoryTemplateListAsync(action) {
  const result = yield call(getInventoryTemplateList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_INVENTORY_TEMPLATE_LIST_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* postInventoryTemplateListAsync(action) {
  const result = yield call(postInventoryTemplateList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.POST_INVENTORY_TEMPLATE_LIST_SUCCESS,
      data: result.data
    });
    yield put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Imported'});

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getInventoryItemTemplateListAsync(action) {
  const result = yield call(getInventoryItemTemplateList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getRequestTypeToMappingAsync(action) {
  const result = yield call(getRequestTypeToMapping, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.GET_REQUEST_TYPE_TO_MAPPING_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* postRequestTypeTemplateAsync(action) {
  const result = yield call(postRequestTypeTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS
    });

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* deleteRequestTypeTemplateAsync(action) {
  const result = yield call(deleteRequestTypeTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS
    });

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* postInventoryItemTemplateListAsync(action) {
  const result = action.isImportDirect
    ? yield call(postInventoryItemTemplateNotExistList, action.params)
    : yield call(postInventoryItemTemplateList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ProjectActionType.POST_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS,
      data: result.data
    });
    yield put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Imported'});

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export default function* WatchProjects() {
  yield all([
    takeLatest(ProjectActionType.GET_PROJECT_BY_ID_ASYNC, getByIdAsync),
    takeLatest(ProjectActionType.SEARCH_PROJECT_ASYNC, searchAsync),
    takeEvery(ProjectActionType.CREATE_PROJECT_ASYNC, createAsync),
    takeEvery(ProjectActionType.UPDATE_PROJECT_ASYNC, updateAsync),
    takeLatest(
      ProjectActionType.SELECT_LIST_PROJECT_ASYNC,
      selectListProjectAsync
    ),
    takeLatest(ProjectActionType.SELECT_LIST_LOT_ASYNC, selectListLotAsync),
    takeLatest(
      ProjectActionType.GET_LIST_PROJECT_ASSIGNMENT_USER_ASYNC,
      getListProjectAssignmentUserAsync
    ),
    takeLatest(
      ProjectActionType.ASSIGN_USER_TO_PROJECT_ASYNC,
      assignUserToProjectAsync
    ),
    takeLatest(
      ProjectActionType.GET_LIST_BUILDER_USER_ASYNC,
      getListBuilderUserAsync
    ),
    takeLatest(ProjectActionType.GET_LIST_USER_ASYNC, getListUserSelectAsync),
    takeLatest(
      ProjectActionType.SELECT_SUBCONTRACTOR_LIST_PROJECT_ASYNC,
      selectSubcontractorListProjectAsync
    ),
    takeLatest(
      ProjectActionType.SELECT_BUILDER_LIST_PROJECT_ASYNC,
      selectBuilderListProjectAsync
    ),
    takeLatest(
      ProjectActionType.GET_PROJECT_SETTING_ASYNC,
      getProjectSettingAsync
    ),
    takeLatest(
      ProjectActionType.UPDATE_PROJECT_SETTING_ASYNC,
      updateProjectSettingAsync
    ),
    takeLatest(
      ProjectActionType.GET_PROJECT_SETTING_NOTICE_RFS_ASYNC,
      getProjectSettingNoticeRFSAsync
    ),
    takeLatest(
      ProjectActionType.UPDATE_PROJECT_SETTING_NOTICE_RFS_ASYNC,
      updateProjectSettingNoticeRFSAsync
    ),
    takeLatest(
      ProjectActionType.SETTING_UPDATE_ASSIGNEE_NOTICE_ASYNC,
      createAssigneeNoticeAsync
    ),
    takeLatest(
      ProjectActionType.GET_SETTING_ASSIGNEE_NOTICE_BY_PROJECT_ASYNC,
      getAssigneeNoticeByProjectAsync
    ),
    takeLatest(
      ProjectActionType.GET_PROJECT_BY_USER_ID_ASYNC,
      getProjectByUserIdAsync
    ),
    takeLatest(
      ProjectActionType.REASSIGN_PROJECT_COORDINATOR_ASYNC,
      reassignProjectCoordinatorAsync
    ),
    takeLatest(
      ProjectActionType.REASSIGN_PROJECT_OWNER_ASYNC,
      reassignProjectOwnerAsync
    ),
    takeLatest(
      ProjectActionType.GET_LIST_PROJECT_DOCUMENT_TYPE_ASYNC,
      getListProjectDocumentTypeAsync
    ),
    takeEvery(
      ProjectActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
      getProjectDocumentByDocumentTypeAsync
    ),
    takeEvery(
      ProjectActionType.UPLOAD_PROJECT_DOCUMENT_TO_SERVER_ASYNC,
      uploadProjectDocumentToServerAsync
    ),
    takeEvery(
      ProjectActionType.REMOVE_PROJECT_DOCUMENT_ASYNC,
      removeProjectDocumentAsync
    ),
    takeEvery(
      ProjectActionType.UPDATE_PROJECT_DOCUMENT_NAME_ASYNC,
      updateProjectDocumentNameAsync
    ),
    takeEvery(
      ProjectActionType.GET_PROJECT_DOCUMENT_SHARE_LOT_ASYNC,
      getProjectDocumentShareLotAsync
    ),
    takeEvery(
      ProjectActionType.UPDATE_PROJECT_DOCUMENT_SHARE_LOT_ASYNC,
      updateProjectDocumentShareLotAsync
    ),
    takeLatest(ProjectActionType.EXPORT_PROJECT_LIST, exportProjectListAsync),
    takeLatest(
      ProjectActionType.UPDATE_HOMEOWNER_MANUAL_FOLDER_TITLE_ASYNC,
      updateHomeownerFolderTitleAsync
    ),
    takeLatest(
      ProjectActionType.IMPORT_RFS_TO_PROJECT_ASYNC,
      importRFSToProjectAsync
    ),
    takeLatest(
      ProjectActionType.GET_IMPORT_STATUS_BY_PROJECT_ASYNC,
      getImportStatusByProjectAsync
    ),
    takeLatest(
      ProjectActionType.IMPORT_WORK_ORDER_TO_PROJECT_ASYNC,
      importWorkOrderToProjectAsync
    ),
    takeLatest(
      ProjectActionType.IMPORT_PURCHASE_ORDER_TO_PROJECT_ASYNC,
      importPurchaseOrderToProjectAsync
    ),
    takeLatest(ProjectActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE_ASYNC, getListDefaultCustomTemplateAsync),
    takeLatest(ProjectActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_ASYNC, getListDefaultCustomTemplate2Async),
    takeLatest(ProjectActionType.CREATE_NEW_PROJECT_EOC_TEMPLATE_ASYNC, createNewProjectEOCTemplateAsync),
    takeLatest(ProjectActionType.CREATE_NEW_PROJECT_EPL_TEMPLATE_ASYNC, createNewProjectEPLTemplateAsync),
    takeLatest(ProjectActionType.SELECT_CUSTOM_TEMPLATE_ASYNC , selectListCustomTemplateAsync),
    takeLatest(ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL_ASYNC, getCustomTemplateDetailAsync),
    takeLatest(ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL2_ASYNC, getCustomTemplateDetail2Async),
    takeLatest(ProjectActionType.EDIT_CUSTOM_TEMPLATE_ASYNC, editCustomTemplateAsync),
    takeLatest(ProjectActionType.EDIT_EPL_TEMPLATE_ASYNC, editEPLTemplateAsync),
    takeLatest(ProjectActionType.GET_BUILDER_NAME_ASYNC, getBuilderNameAsync),
    takeLatest(ProjectActionType.DUPLICATE_EOC_TEMPLATE_ASYNC, duplicateEOCTemplateAsync),
    takeLatest(ProjectActionType.COPY_EOC_TEMPLATE_ASYNC, copyEOCTemplateAsync),
    takeLatest(ProjectActionType.COPY_EOF_TEMPLATE_ASYNC, copyEOFTemplateAsync),
    takeLatest(ProjectActionType.GET_LIST_COPY_EOC_TEMPLATE_LIST_ASYNC, getListCopyEOCProjectAsync),
    takeLatest(ProjectActionType.CREATE_NEW_CATEGORY_ASYNC, createNewCategoryAsync),
    takeLatest(ProjectActionType.SUGGEST_INFORMATION_CATEGORY_ASYNC, suggestInfoCategoryAsync),
    takeLatest(ProjectActionType.GET_LIST_CATEGORY_ASYNC, getListCategoryAsync),
    takeLatest(ProjectActionType.GET_CATEGORY_PROFILE_DETAILS_ASYNC, getCategoryProfileDetailsAsync),
    takeLatest(ProjectActionType.EDIT_CATEGORY_PROFILE_ASYNC, editCategoryProfileAsync),
    takeLatest(ProjectActionType.GET_SELECTED_TEMPLATE_CATEGORY_ASYNC, getSelectedTemplateCategoryAsync),
    takeLatest(ProjectActionType.EDIT_CATEGORY_IMAGE_ASYNC, editCategoryImagesAsync),
    takeLatest(ProjectActionType.DELETE_CATEGORY_IMAGE_ASYNC, deleteCategoryImagesAsync),
    takeLatest(ProjectActionType.DELETE_CATEGORY_ITEM_ASYNC, deleteCategoryItemAsync),
    takeLatest(ProjectActionType.CREATE_NEW_INVENTORY_ITEM_ASYNC, createNewInventoryItemAsync),
    takeLatest(ProjectActionType.GET_LIST_CATEGORY_DROPDOWN_ASYNC, getListCategoryDropdownAsync),
    takeLatest(ProjectActionType.GET_LIST_INVENTORY_ITEM_ASYNC, getListInventoryItemAsync),
    takeLatest(ProjectActionType.GET_INVENTORY_ITEM_PROFILE_ASYNC, getInventoryItemProfileAsync),
    takeLatest(ProjectActionType.DELETE_INVENTORY_ITEM_IMAGES_ASYNC, deleteImageInventoryItemAsync),
    takeLatest(ProjectActionType.DELETE_INVENTORY_ITEM_ATTACHMENT_ASYNC, deleteAttachFileInventoryItemAsync),
    takeLatest(ProjectActionType.ADD_INVENTORY_ITEM_IMAGES_ASYNC, postImageInventoryItemAsync),
    takeEvery(ProjectActionType.ADD_INVENTORY_ITEM_ATTACHMENT_ASYNC, postAttachFileInventoryItemAsync),
    takeLatest(ProjectActionType.DELETE_INVENTORY_ITEM_ASYNC, deleteInventoryItemAsync),
    takeLatest(ProjectActionType.EDIT_INVENTORY_ITEM_ASYNC, editInventoryItemAsync),
    takeLatest(ProjectActionType.GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_ASYNC, getListPhaseToLotInventoryItemAsync),
    takeLatest(ProjectActionType.ASSIGN_PLAN_TO_LOT_INVENTORY_ITEM_ASYNC, assignPlanToLotInventoryItemAsync),
    takeLatest(ProjectActionType.GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_ASYNC, getListLotAssignInventoryItemAsync),
    takeLatest(ProjectActionType.UPDATE_LOT_LIST_INVENTORY_ASYNC, onEditListLotInventoryItemAsync),
    takeLatest(ProjectActionType.DELETE_LOT_LIST_INVENTORY_ITEM_ASYNC, deleteListLotInventoryItemAsync),
    takeLatest(ProjectActionType.GET_SUGGEST_TEMPLATE_NAME_ASYNC, getSuggestTemplateNameAsync),
    takeLatest(ProjectActionType.GET_SUGGEST_DATA_ASYNC, getSuggestDataAsync),
    takeLatest(ProjectActionType.GET_INVENTORY_ITEM_IMAGES_ASYNC, getImagesItemProfileAsync),
    takeEvery(ProjectActionType.GET_INVENTORY_ITEM_ATTACHMENT_ASYNC, getAttachmentsItemProfileAsync),
    takeLatest(ProjectActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC ,getCategoryProfileImagesDetailsAsync),
    takeEvery(ProjectActionType.SETUP_PROJECT_DOCUMENT_AWS_ASYNC, setupProjectDocumentAWSAsync),
    takeEvery(ProjectActionType.UPLOAD_PROJECT_DOCUMENT_TO_S3_ASYNC, uploadProjectDocumentToS3Async),
    takeLatest(ProjectActionType.SUGGEST_LOCATION_TAGS_HOME_INVENTORY_ASYNC, suggestLocationTagsHomeInventoryAsync),
    takeLatest(ProjectActionType.GET_INVENTORY_TEMPLATE_LIST_ASYNC, getInventoryTemplateListAsync),
    takeLatest(ProjectActionType.POST_INVENTORY_TEMPLATE_LIST_ASYNC, postInventoryTemplateListAsync),
    takeLatest(ProjectActionType.GET_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC, getInventoryItemTemplateListAsync),
    takeLatest(ProjectActionType.POST_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC, postInventoryItemTemplateListAsync),
    takeLatest(ProjectActionType.GET_REQUEST_TYPE_TO_MAPPING_ASYNC, getRequestTypeToMappingAsync),
    takeLatest(ProjectActionType.POST_REQUEST_TYPE_TEMPLATE_ASYNC, postRequestTypeTemplateAsync),
    takeLatest(ProjectActionType.DELETE_REQUEST_TYPE_TEMPLATE_ASYNC, deleteRequestTypeTemplateAsync),
    MaintenanceSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/Projects/saga.js